export default "__VITE_ASSET__C9xW3kuw__"